<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          結果
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">結果</a>
          </li>
      </ul>
    </div>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>スキャン結果の詳細</strong>
              <strong style="float:right;">チェック時間 {{model.scan_time | datetime}}</strong>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>エージェント</div>
                <div title="" v-if="model && model.agent">
                  {{model.agent.name}}
                  <span v-if="model.agent.name != model.agent.host">
                    ({{model.agent.host}})
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IPアドレス(パブリック)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_public}}</div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IPアドレス(プライベート)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_private}}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="検査にかかった時間を表示します。手動チェックにかかるおおよその時間を表示">
                  スキャン時間
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div>
                  {{model.scanning_time}}
                </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <div class="m-1" v-b-tooltip.hover>確認フォルダ / 確認ファイル</div>
                <div>{{model.scan_folder | number}} 確認済み / {{model.scan_count | number}} 確認済み </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="検査にかかった時間を表示">
                  検出回数
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div> {{model.detect_count | number}}</div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="隔離モードに対応しているため、隔離された検出履歴の数を表示">
                  隔離回数
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div> {{model.backup_count | number}} </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="model.setting && model.setting.rule">
          <b-row v-if="model.setting && model.setting.rule">
            <b-col md="12">
              <b-button block href="#" variant="success" v-b-tooltip.hover.top title="検査実施時の検査ポリシーを表示" class="btn-add">
                設定
                <span>
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </b-button>
            </b-col>
          </b-row>
          <hr v-if="model.setting && model.setting.rule">
          <b-row class="text-center" v-if="model.setting && model.setting.rule">
            <b-col>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="検査に使用するポリシーを設定">
                    * スキャンポリシー
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>

                </div>
                <b-form-checkbox-group id="ph_status" v-model="model.setting.rule" :disabled="true">
                  <b-form-checkbox value="Regex">正規表現</b-form-checkbox>
                  <b-form-checkbox value="Hash">ハッシュ</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">Ssdeep</b-form-checkbox>
                  <b-form-checkbox value="OB">難読化</b-form-checkbox>
                  <!-- <b-form-checkbox value="ML">機械学習</b-form-checkbox> -->
                </b-form-checkbox-group>
              </b-form-group>
              <br>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="リアルタイム監視するかどうかを設定">
                    リアルタイム監視
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group :disabled="true" id="ph_realtime_mode_type" v-model="model.setting.realtime_mode">
                  <b-form-radio :value="true">有効</b-form-radio>
                  <b-form-radio :value="false">無効</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="4" label="">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="検査スケジュールを設定します。夜明けまたはサーバー リソースに負荷がかかっていない時間帯に、最大 10 個の構成を推奨します。">
                    * スケジュールの確認
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                    <br>
                    <small>最大10個のスケジュールを設定可能</small>
                  </span>
                </div>
                <Schedule :readonly="true" :now_schedule="model.setting.schedule" :hide_text="true" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col>
              <b-form-group :label-cols="2">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="検出されたWebシェルファイルをバックアップするかどうかを設定します。バックアップ後、ファイルはWebからアクセスできなくなります。これは推奨設定ですが、タイプミスのあるファイルはバックアップされる可能性があります。">
                    隔離モード
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group :disabled="true" style="display:inline-block" v-model="model.setting.backup_mode">
                  <b-form-radio :value="false">手動</b-form-radio>
                  <b-form-radio :value="true">自動</b-form-radio>
                </b-form-radio-group>
                [
                <b-form-checkbox-group :disabled="true" style="display:inline-block" v-model="model.setting.backup_type_list">
                  <b-form-checkbox value="Regex">正規表現</b-form-checkbox>
                  <b-form-checkbox value="Hash">ハッシュ</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">Ssdeep</b-form-checkbox>
                  <!-- <b-form-checkbox value="OB">難読化</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="OB">難読化</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="ML">機械学習</b-form-checkbox> -->
                </b-form-checkbox-group>
                ] <br> <small class="text-danger">* 難読化は自動的な分離を利用できません</small>
              </b-form-group>
            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.bottom title="分離パスを設定します。パスが存在しない場合は、そのパス上にフォルダーが自動的に作成されます。Windowsの場合はデフォルトで「C:\wfinder_backup」、Linux の場合は「/opt/f1/wsfinder_backup」がインストール時にデフォルトに設定されます">
                    隔離パス
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                  <b-form-input placeholder="フォルダーパスが必要です" :disabled="true" id="input-small3" type="text" v-model="model.setting.backup_path"></b-form-input>
                  <!-- <b-button size="sm" variant="link" @click="modal_scan_list_history = true">前回の記録</b-button> -->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <hr>
              <b-button style="position: relative; top:-30px; width: 80%;" v-b-toggle.collapse-1-inner size="sm" variant="light">その他のオプション</b-button>
            </b-col>
          </b-row>

          <b-collapse id="collapse-1-inner" class="mt-2">
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="検査対象の拡張子でフィルタリングできます。特定のファイルのみを監視する場合に使用します">
                      拡張設定
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                    <b-form-input :disabled="true" type="text" v-model="converter"></b-form-input>
                  </b-input-group>
                  <small class="help-block">拡張設定・例) txt,php,aspx,js, ...</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="監視しているフォルダー内のサブ条件のサイズを持つファイルのみをスキャンします">
                      最大ファイルサイズ
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                      <b-form-input :disabled="true" type="number" v-model="model.setting.max_filesize"></b-form-input>
                  </b-input-group>
                  <small class="help-block">デフォルト : 10M</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="更新されたシステムパターンを自動的に適用して確認するかどうかを設定します。これらの設定を有効にすることをお勧めします。使用しない場合は、更新されたパターンを手動で更新できます">
                      パターンを自動で適用
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                    <!-- 시스템 패턴 자동 적용 -->
                  </div>
                  <b-form-radio-group v-if="model.setting" v-model="model.setting.is_allow_system" :disabled="true">
                    <b-form-radio :value="true">有効</b-form-radio>
                    <b-form-radio :value="false">無効</b-form-radio>
                    <b-button class="btn-add" size="sm" variant="success" :disabled="true">
                      <b-badge pill variant="warning" >{{ model.available_system_pattern_count | number }}</b-badge>
                      <span v-if="!model.is_testing">
                        追加のシステムパターンを適用することができます。
                      </span>
                      <span v-else>
                        テストを依頼し、結果をメールで送信します。
                      </span>
                    </b-button>
                  </b-form-radio-group>
                  <small class="text-danger">使用を推奨します</small>
                </b-form-group>
              </b-col>
            </b-row>
          <!--  <hr>
          <b-row class="text-center">
            <b-col sm="12">
              <p style="display:inline-block; cursor: pointer;" @click="model.setting.limit_mode = !model.setting.limit_mode">
                <span v-b-tooltip.hover.right title="インストールされたサーバーのリソースを監視します。設定した限界値到達時にメール通知を受け取ることができます">
                  リソースモニタリング通知
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <i v-if="model.setting.limit_mode" class="fa fa-refresh fa-spin"></i>
              </p>
              <c-switch :disabled="true" class="float-right" color="success" label variant="pill" v-model="model.setting.limit_mode"/>
              <br>
              <small class="text-danger">システムリソースがしきい値以上の場合、最初に1回通知が発生し、正常基準になると再通知が可能です。しきい値は90%、正常基準は60%を推奨します。</small>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU しきい値(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM しきい値(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk しきい値(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU 通常(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 通常(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 通常(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row> -->
        </b-collapse>
          <hr>
          <b-row>
            <b-col md="12">
              <b-button block href="#" variant="danger">
                検出一覧
              </b-button>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="12">
              <b-form-group>
                <pre class="text-left" v-if="detect_list" style="margin:0 auto; background-color:#f5f5f5; border:1px solid #ccc; padding:10px; max-height: 500px; max-width: 1500px; overflow: auto;">{{detect_list}}</pre>
                <span v-else>いいえ、何かが検出されました。</span>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-button v-if="!(id || result_data) && detect_list.length" size="sm" variant="success" @click="save_rs" class="btn-add"> ダウンロード </b-button>
          <b-button block v-if="(id || result_data) && detect_list.length" size="sm" variant="success" @click="save_rs" class="btn-add"> ダウンロード </b-button>
          <b-button v-if="!id && !result_data" size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
